(() => {
  const format = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(cents/100);
  function init(root) {
    if(root.dataset.ready) return; root.dataset.ready='1';
    const singleId=Number(root.dataset.singleId),albumId=Number(root.dataset.albumId);
    const singlePrice=Number(root.dataset.singlePrice),albumPrice=Number(root.dataset.albumPrice);
    const purchase=[...root.querySelectorAll('input[name^="sm-purchase-"]')];
    const license=[...root.querySelectorAll('input[name^="sm-license-"]')];
    const tracks=[...root.querySelectorAll('[data-sm-track]')];
    const tracksBox=root.querySelector('[data-sm-tracks]'),total=root.querySelector('[data-sm-total]');
    const submit=root.querySelector('[data-sm-submit]'),status=root.querySelector('[data-sm-status]');
    const selected=(radios)=>radios.find(x=>x.checked)?.value;
    const xmas=root.querySelector('[data-sm-xmas]');
    const xmasAreas=xmas?[...xmas.querySelectorAll('input[name^="sm-xmas-area-"]')]:[];
    const xmasLarge=xmas?.querySelector('[data-sm-xmas-large]');
    const xmasSize=xmas?.querySelector('[data-sm-xmas-size]');
    const xmasDuration=xmas?.querySelector('[data-sm-xmas-duration]');
    const xmasPrices={year:[29900,49900,79900,99900],unlimited:[59900,144900,244900,350000]};
    function xmasIsLarge(){return !!xmas&&selected(license)==='Gewerbliche Beschallung'&&selected(xmasAreas)==='large';}
    function xmasUsage(){
      if(!xmas||selected(license)!=='Gewerbliche Beschallung')return selected(license);
      if(selected(xmasAreas)==='small')return 'Weihnachtsmarkt bis 200 m² – 1 Saison';
      return 'Gewerbliche Beschallung – unbegrenzte Gewerbefläche (kein Weihnachtsmarkt über 200 m²)';
    }
    function updateXmas(){
      if(!xmas)return;
      xmas.querySelector('[data-sm-xmas-area]').hidden=selected(license)!=='Gewerbliche Beschallung';
      xmasLarge.hidden=!xmasIsLarge();
      if(xmasIsLarge()){
        const price=xmasPrices[xmasDuration.value][Number(xmasSize.value)];
        xmas.querySelector('[data-sm-xmas-price]').textContent=format(price);
        const desc=xmasSize.options[xmasSize.selectedIndex].text+'; '+xmasDuration.options[xmasDuration.selectedIndex].text;
        // The inquiry email is composed on form submission, not on every selection change.
      }
    }
    function update(){
      const isAlbum=selected(purchase)==='album';
      tracksBox.hidden=isAlbum;
      const count=tracks.reduce((n,x)=>n+(Number.isInteger(Number(x.value)) && Number(x.value)>=0?Number(x.value):0),0);
      total.textContent=format(isAlbum?albumPrice:count*singlePrice);
      submit.disabled=xmasIsLarge()||(isAlbum?root.dataset.albumAvailable!=='true':root.dataset.singleAvailable!=='true'||count===0);
      submit.hidden=xmasIsLarge();
      updateXmas();
    }
    const inquiryForm=xmas?.querySelector('[data-sm-xmas-form]');
    inquiryForm?.addEventListener('submit',event=>{
      event.preventDefault();
      if(!inquiryForm.reportValidity())return;
      const area=xmasSize.options[xmasSize.selectedIndex].text;
      const duration=xmasDuration.options[xmasDuration.selectedIndex].text;
      const price=format(xmasPrices[xmasDuration.value][Number(xmasSize.value)]);
      const val=key=>inquiryForm.querySelector('[data-sm-xmas-'+key+']')?.value.trim()||'';
      const body=[
        'Guten Tag,','',
        'ich möchte folgende Weihnachtsmarktlizenz unverbindlich anfragen:','',
        'Angefragte Lizenz: Weihnachtsmarktlizenz – alle Weihnachtsmusiktitel',
        'Beschallte Fläche: '+area,
        'Lizenzlaufzeit: '+duration,
        'Angezeigter Lizenzpreis: '+price,
        '',
        'Stadt des Weihnachtsmarktes: '+val('city'),
        'Ansprechpartner/in: '+val('person'),
        'Kontaktdaten: '+val('contact'),
        '',
        'Ihre Nachricht:',
        val('message')||'(keine weiteren Angaben)',
        '',
        'Mit freundlichen Grüßen',
        val('person')
      ].join('\r\n');
      window.location.href='mailto:info@schlierkampmusic.com?subject='+encodeURIComponent('Anfrage Weihnachtsmarktlizenz – '+val('city'))+'&body='+encodeURIComponent(body);
    });
    [...purchase,...license,...tracks,...xmasAreas,xmasSize,xmasDuration].filter(Boolean).forEach(el=>el.addEventListener('change',update));
    tracks.forEach(el=>el.addEventListener('input',update));
    submit.addEventListener('click',async()=>{
      if(xmasIsLarge()){status.textContent='Für Weihnachtsmärkte über 200 m² ist eine gesonderte Lizenz erforderlich.';return;}
      const isAlbum=selected(purchase)==='album',usage=xmasUsage();
      const items=[];
      if(isAlbum)items.push({id:albumId,quantity:1,properties:{'Nutzungsart':usage,'Lizenzumfang':'Album – jeder Titel einmal für ein Projekt oder gewerbliche Beschallung'}});
      else for(const x of tracks){
        const q=Number(x.value);
        if(!Number.isInteger(q)||q<0||q>99){status.textContent='Bitte eine gültige Anzahl zwischen 0 und 99 eingeben.';return;}
        if(q)items.push({id:singleId,quantity:q,properties:{'Musiktitel':x.dataset.smTrack,'Nutzungsart':usage,'Lizenzumfang':'Eine Lizenz pro Exemplar für die gewählte Nutzungsart'}});
      }
      if(!items.length)return;
      submit.disabled=true;status.textContent='Warenkorb wird aktualisiert …';
      try{
        const rootUrl=window.Shopify?.routes?.root||'/';
        const res=await fetch(rootUrl+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if(!res.ok){const err=await res.json().catch(()=>({}));throw new Error(err.description||'Fehler beim Hinzufügen ('+res.status+').');}
        window.location.assign(rootUrl+'cart');
      }catch(err){status.textContent=err.message||'Bitte erneut versuchen.';update();}
    });
    update();
  }
  function start(){document.querySelectorAll('[data-sm-pilot]').forEach(init);}
  document.addEventListener('DOMContentLoaded',start);
  document.addEventListener('shopify:section:load',start);
  if(document.readyState!=='loading')start();
})();
